require('./Resources/js/angular/app');
require('./Resources/js/angular/module');
require('./Resources/js/angular/controllers/MediaStatsSearchCtrl');
require('./Resources/js/angular/controllers/StatResultsCtrl');
require('./Resources/js/angular/controllers/SubjectListCtrl');
require('./Resources/js/angular/controllers/SubjectListModalCtrl');
require('./Resources/js/angular/services/Stat');
require('./Resources/js/angular/services/StatLoader');
require('./Resources/js/angular/services/SubjectListModal');



// WEBPACK FOOTER //
// ./vendor/sonyatv/mediastatsclientbundle/index.js